<template>
  <div>
    <b-form-group>
       
        <b-form-group
          label="Nº total de filho no Agregado Familiar"
        >
        <b-form-select v-model="value.n_kids" 
            @change="updateKidsNumber()" :options="kidsOptions" class="mb-3"></b-form-select>
 
        </b-form-group> 
    </b-form-group>
    <b-form-group label="Dados do filho" v-for="(item, index) in value.kids_data" v-bind:key="index" >
      <children-data :label="'filho'+index" :name="'child_'+index" v-model="value.kids_data[index]"  />
    </b-form-group>
  </div>
</template>
<script>
import ChildrenData from './children_data.vue'
export default {
  name: "ParentsForm",
  components: { ChildrenData },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      kidsOptions: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]
    }
  },
  watch: {
    value() {
      this.$emit("input", this.value);
    },
  },
  methods: {
    validateState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    updateKidsNumber() {
      if(this.value.kids_data.length < this.value.n_kids) {
        while(this.value.kids_data.length < this.value.n_kids) {
          this.value.kids_data.push({name:null, birthdate:null})
        }
      } else {
        while(this.value.kids_data.length > this.value.n_kids) {
          this.value.kids_data.pop()
        }
      }
      
    }
  },
};
</script>
